export const API_ENDPOINTS = {
  // Session Management
  createSession: '/', // POST /onboardingIntakeApi/
  getUserSessions: '/user-sessions', // GET
  updateSessionTitle: '/session-title', // POST
  createSessionFromUser: '/user-create-session', // POST
  addUsersToSessionBySessionId: '/users-to-session-by-session-id', // POST
  
  // Community Management  
  addCommunitiesFromGalactus: '/communities-from-galactus-ids', // POST
  addCommunitiesFromPlaceIds: '/communities-from-place-ids-and-names', // POST
  upsertCommunities: '/communities', // POST
  deleteCommunities: '/communities', // DELETE
  submitCommunities: '/submit-communities', // POST
  submitCommunityCharacteristics: '/submit-community-characteristics', // POST
  submitImplementationContacts: '/submit-implementation-contacts', // POST (legacy)
  submitPOCs: '/submit-pocs', // POST (preferred)
  submitPLG: '/submit-plg', // POST
  
  // Search & Autocomplete
  googleMapsAutocomplete: '/google-maps-places-autocomplete', // GET
  galactusAutocomplete: '/galactus-buildings-autocomplete', // GET
  
  // State & Schema
  getState: '/state', // GET with query param
  getSchema: '/schema', // GET with query param
  
  // CLO Groups
  upsertCLOGroups: '/clo-groups', // POST
  deleteCLOGroup: '/clo-groups', // DELETE
  
} as const;